type Country = {
  alternativeLocaleCodes?: string[]
  code: string
  localeCode: string
}

export const countries: Country[] = [
  {
    alternativeLocaleCodes: ['ca'],
    code: 'ES',
    localeCode: 'es',
  },
  {
    code: 'IT',
    localeCode: 'it',
  },
  {
    alternativeLocaleCodes: ['ru'],
    code: 'UA',
    localeCode: 'uk',
  },
  {
    code: 'RO',
    localeCode: 'ro',
  },
  {
    alternativeLocaleCodes: ['ru'],
    code: 'GE',
    localeCode: 'ka',
  },
  {
    code: 'PT',
    localeCode: 'pt',
  },
  {
    code: 'PL',
    localeCode: 'pl',
  },
  {
    code: 'MA',
    localeCode: 'fr',
  },
  {
    alternativeLocaleCodes: ['kk'],
    code: 'KZ',
    localeCode: 'ru',
  },
  {
    code: 'HR',
    localeCode: 'hr',
  },
  {
    code: 'KE',
    localeCode: 'en',
  },
  {
    code: 'CI',
    localeCode: 'fr',
  },
  {
    code: 'RS',
    localeCode: 'sr',
  },
  {
    alternativeLocaleCodes: ['ru'],
    code: 'MD',
    localeCode: 'ro',
  },
  {
    code: 'UG',
    localeCode: 'en',
  },
  {
    code: 'KG',
    localeCode: 'ru',
  },
  {
    alternativeLocaleCodes: ['hr', 'sr'],
    code: 'BA',
    localeCode: 'bs',
  },
  {
    code: 'BG',
    localeCode: 'bg',
  },
  {
    code: 'ME',
    localeCode: 'sr',
  },
  {
    code: 'SI',
    localeCode: 'sl',
  },
  {
    code: 'NG',
    localeCode: 'en',
  },
  {
    code: 'AM',
    localeCode: 'hy',
  },
  {
    code: 'AD',
    localeCode: 'ca',
  },
  {
    code: 'TN',
    localeCode: 'fr',
  },
]
